import { Container, Col } from "react-bootstrap";
import {
  Award,
  Gear,
  Mortarboard,
  Basket3,
  FileEarmarkText,
  ChatDots,
  GeoAlt,
  Rocket,
} from "react-bootstrap-icons";
import PageHero from "../ui/PageHero";
import SectionHeading from "../ui/SectionHeading";
import { Reveal, RevealGroup, RevealItem } from "../ui/Reveal";
import "../style/Franchise.css";

const BENEFITS = [
  {
    icon: Award,
    title: "Authenticity Redefined",
    text: "We're committed to preserving traditional recipes, delivering an unparalleled taste experience to every customer.",
  },
  {
    icon: Gear,
    title: "A Proven Business Model",
    text: "From sourcing quality ingredients to efficient kitchen processes, the operation is figured out so you can focus on customers.",
  },
  {
    icon: Mortarboard,
    title: "Comprehensive Training",
    text: "No culinary background needed. Our training covers menu preparation through customer service, start to finish.",
  },
  {
    icon: Basket3,
    title: "Premium Ingredients",
    text: "Only the finest, freshest ingredients go into every dish, with a special emphasis on real South Indian flavor.",
  },
];

const STEPS = [
  {
    icon: FileEarmarkText,
    title: "Submit Your Application",
    text: "Fill out our franchise application form and tell us about your vision for your Kote Cafe.",
  },
  {
    icon: ChatDots,
    title: "Initial Consultation",
    text: "We'll schedule a call to discuss the opportunity, answer your questions, and outline what it takes to succeed.",
  },
  {
    icon: GeoAlt,
    title: "Location Assessment",
    text: "We help identify the right site for visibility and foot traffic. Currently tailored for North Karnataka.",
  },
  {
    icon: Mortarboard,
    title: "Training Program",
    text: "A hands-on program covering kitchen operations and customer service, so you're ready on day one.",
  },
  {
    icon: Rocket,
    title: "Grand Opening Support",
    text: "We assist with marketing strategies and promotional events to make your launch a success.",
  },
  {
    icon: ChatDots,
    title: "Ongoing Support",
    text: "Continuous marketing initiatives, operational guidance, and regular updates keep your franchise thriving.",
  },
];

const Franchisepage = () => {
  return (
    <div>
      <PageHero
        eyebrow="Franchise Opportunity"
        title="Bring Kote Cafe to Your City"
        subtitle="Calling all entrepreneurs with a passion for authentic South Indian cuisine — join us in bringing the taste of tradition to North Karnataka."
      />

      <section className="section-pad franchise-benefits">
        <Container className="container-narrow">
          <SectionHeading
            eyebrow="Why Choose Us"
            title="Built for Entrepreneurs Who Care About Quality"
          />
          <RevealGroup className="row g-4">
            {BENEFITS.map(({ icon: Icon, title, text }, i) => (
              <Col sm={6} lg={3} key={title} className="d-flex">
                <RevealItem delay={i * 80} className="franchise-benefits__card card-surface">
                  <Icon size={26} className="franchise-benefits__icon" />
                  <h3>{title}</h3>
                  <p>{text}</p>
                </RevealItem>
              </Col>
            ))}
          </RevealGroup>
        </Container>
      </section>

      <section className="section-pad franchise-steps">
        <Container className="container-narrow">
          <SectionHeading
            eyebrow="The Process"
            title="Steps to Become a Franchisee"
          />
          <RevealGroup className="franchise-steps__list">
            {STEPS.map(({ icon: Icon, title, text }, i) => (
              <RevealItem
                as="div"
                delay={i * 70}
                className="franchise-steps__item"
                key={title}
              >
                <div className="franchise-steps__number">
                  <Icon size={20} />
                </div>
                <div>
                  <h3>{title}</h3>
                  <p>{text}</p>
                </div>
              </RevealItem>
            ))}
          </RevealGroup>
        </Container>
      </section>

      <Reveal as="section" className="franchise-cta">
        <Container className="container-narrow franchise-cta__inner">
          <h2>Ready to Embark on a Delicious Journey?</h2>
          <p>
            Call us today or fill the form below to learn more about franchise
            opportunities with Kote Cafe.
          </p>
          <a href="tel:+916363018056" className="btn-turmeric">
            Call +91 63630 18056
          </a>
        </Container>
      </Reveal>
    </div>
  );
};

export default Franchisepage;
